import { render, staticRenderFns } from "./HomePageContentManager.vue?vue&type=template&id=64b94014&"
import script from "./HomePageContentManager.vue?vue&type=script&lang=ts&"
export * from "./HomePageContentManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports